import { Box, Divider, Snackbar, Stack, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { TabPanel } from "../tab-panel.js";
import usePricingManagamentAlertsStore from "../stores/pricing-management-alerts.store.ts";
import DealsPage from "./pages/deals-page.tsx";
import AnalyzerPage from "./pages/analyzer-page.tsx";
import useDatabaseAPI from "./hooks/useDatabaseAPI.ts";

enum Page {
  DEALS,
  ANALYZE
}

export default function PricingManagementMain() {
  const { loadDeals } = useDatabaseAPI();
  const { setSnackMessage, snackMessage } = usePricingManagamentAlertsStore();
  const [activeTab, setActiveTab] = useState<Page>(Page.DEALS);

  useEffect(() => { loadDeals() }, []);

  return (
    <Stack direction="column" sx={{ background: "white", flex: 1 }}>
      <Tabs 
        value={activeTab} 
        onChange={(e, v) => setActiveTab(v)}
        sx={{ backgroundd: "white" }}
      >
        <Tab label="Deals" value={Page.DEALS} />
        <Tab label="Bid Pricing Analyzer" value={Page.ANALYZE} />
      </Tabs>
      <Divider />
      <Box width="100%" flex={1} sx={{ background: "#fafafa" }}>
        <TabPanel activeTab={activeTab} name={Page.DEALS}>
          <DealsPage />
        </TabPanel>
        <TabPanel activeTab={activeTab} name={Page.ANALYZE}>
          <AnalyzerPage  />
        </TabPanel>
      </Box>
      <Snackbar
				color="error"
				open={snackMessage !== undefined}
				autoHideDuration={6000}
				onClose={() => setSnackMessage(undefined)}
				message={snackMessage}
			/>
    </Stack>
  )
}
